import useStoreValues from '~/utility/use-store-values';

const updateQuery = (params) => {
  const searchParams = new URLSearchParams(window.location.search);
  Object.entries(params).forEach(([key, value]) => {
    value ? searchParams.set(key, value) : searchParams.delete(key);
  });
  window.history.replaceState(null, '', `${window.location.pathname}?${searchParams}`);
};

export function useQuery() {
  const { queryV2: query = {} } = useStoreValues(['queryV2']);
  return [ query, updateQuery];
}
